import FormDialog from "@/core/components/v2/FormDialog";
import { LoadingButton } from "@mui/lab";
import { Card, Chip, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";

interface AssetPickerProps<T> {
  onSelect: (asset: T[]) => void;
  onDelete: (asset: T) => void;
  selected: T[];
  idFieldExtractor: (asset: T) => string;
  labelFieldExtractor: (asset: T) => string;
  pickerContent?: React.ReactNode;
  buttonContent?: React.ReactNode;
  pickerFullScreen?: boolean;
  title?: string;
}

const AssetPicker = <T,>({
  onDelete,
  selected,
  labelFieldExtractor,
  idFieldExtractor,
  pickerContent,
  buttonContent,
  pickerFullScreen,
  title,
}: AssetPickerProps<T>) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gap={1}
      width={"100%"}
      paddingBottom={2}
      paddingTop={2}
    >
      <FormDialog
        fullScreen={pickerFullScreen}
        title={title || "Pick asset(s)"}
        onClose={() => setDialogOpen(false)}
        open={dialogOpen}
        loading={false}
        cancelLabel="Close"
      >
        {pickerContent}
      </FormDialog>
      <Card
        variant="outlined"
        sx={{
          padding: 2,
          visibility: selected.length === 0 ? "hidden" : "visible",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 0.5,
          }}
        >
          {selected.map((val) => (
            <Tooltip
              title={labelFieldExtractor(val)}
              key={idFieldExtractor(val)}
            >
              <Chip
                key={idFieldExtractor(val)}
                label={labelFieldExtractor(val).slice(0, 10) + "..."}
                onMouseDown={(event: any) => {
                  event.stopPropagation();
                }}
                onDelete={() => {
                  onDelete(val);
                }}
              />
            </Tooltip>
          ))}
        </Box>
      </Card>
      <LoadingButton variant="contained" onClick={() => setDialogOpen(true)}>
        {buttonContent || "Pick asset(s)"}
      </LoadingButton>
    </Box>
  );
};
export default AssetPicker;
